import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import { ModalComponent } from './modal/modal.component'
import { DropdownModule } from 'primeng/dropdown';
import { NumberDirective } from './directives/number.directive';
import { JalaliPipe } from './pipes/jalali.pipe';
import { MinuteSecondsPipe } from './pipes/minute-seconds.pipe';
import { NoSanitizePipe } from './pipes/no-sanitize.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HourMinuteSecondsPipe } from './pipes/hour-minute-seconds.pipe';
import { HourMinutePipe } from './pipes/hour-minute.pipe';
import { TimeRemainPipe } from './pipes/time-remain.pipe';
import { NgPagination } from './components/paginator/ng-pagination/ng-pagination.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { TranslateModule } from '@ngx-translate/core';
import { HoursPipe } from './pipes/hours.pipe';
import { MinutesRemainPipe } from './pipes/minutes-remain.pipe';
import { DaysPipe } from './pipes/days.pipe';
import { MinutesPipe } from './pipes/minutes.pipe';
import { DayHourMinutesPipe } from './pipes/day-hour-minutes.pipe';
import { DayHourMinutesRemainPipe } from './pipes/day-hour-minutes-remain.pipe';
import { FilesizePipe } from './pipes/filesize.pipe';
import { JalaliUtcPipe } from './pipes/jalali-utc.pipe';
import { RemainTimePipe } from "./pipes/remain-time.pipe";
import { SecondsRemainPipe } from './pipes/seconds-remain.pipe';
import { ReadableNumberPipe } from './pipes/readable-number/readable-number.pipe';
import { FilePickerComponent } from './components/file-picker/file-picker.component';
import { AbsPipe } from './pipes/abs.pipe';
import { MultiFieldSearchPipe } from './pipes/multi-field-search.pipe';
import { DateDifference } from './pipes/difference-time.pipe';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { RunScriptsDirective } from './directives/run-scripts.directive';
import { StripHtmlPipe } from './pipes/strip-html.pipe';

// import { TranslationModule } from 'src/app/modules/i18n/translation.module';

@NgModule({
  declarations: [
    ModalComponent,
    StripHtmlPipe,
    NoSanitizePipe,
    JalaliPipe,
    JalaliUtcPipe,
    TimeAgoPipe,
    TimeRemainPipe,
    NumberDirective,
    RunScriptsDirective,
    DayHourMinutesPipe,
    MinuteSecondsPipe,
    HourMinuteSecondsPipe,
    HourMinutePipe,
    HoursPipe,
    DayHourMinutesRemainPipe,
    MinutesRemainPipe,
    SecondsRemainPipe,
    MinutesPipe,
    DaysPipe,
    PaginatorComponent,
    NgPagination,
    FilesizePipe,
    RemainTimePipe,
    ReadableNumberPipe,
    FilePickerComponent,
    AbsPipe,
    MultiFieldSearchPipe,
    DateDifference
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    MessageModule,
    MessagesModule,
    ProgressBarModule,
    ToastModule,
    FormsModule,
    DropdownModule,
    DropdownModule,
    FormsModule,
    NgbModule,
    TranslateModule,
    AngularSvgIconModule
  ],
  exports: [
    ModalComponent,
    NumberDirective,
    RunScriptsDirective,
    StripHtmlPipe,
    NoSanitizePipe,
    JalaliPipe,
    JalaliUtcPipe,
    TimeAgoPipe,
    TimeRemainPipe,
    DayHourMinutesPipe,
    MinuteSecondsPipe,
    HourMinuteSecondsPipe,
    HoursPipe,
    DayHourMinutesRemainPipe,
    MinutesRemainPipe,
    SecondsRemainPipe,
    MinutesPipe,
    DaysPipe,
    PaginatorComponent,
    NgPagination,
    FilesizePipe,
    HourMinutePipe,
    RemainTimePipe,
    ReadableNumberPipe,
    AbsPipe,
    FilePickerComponent,
    MultiFieldSearchPipe,
    DateDifference
  ],
})
export class CoreModule {
}
